import { IMemberInternalGetCertRequestParams } from '@/models/Member/interfaces/IMemberInternalGetCertRequestParams';
import { IMemberNewClaimsRequestParams } from '@/models/Member/interfaces/IMemberNewClaimsRequestParams';
import { IMemberNewNolCheckConnectRequestParams } from '@/models/Member/interfaces/IMemberNewNolCheckConnectRequestParams';
import { IMemberNewNolInfoRequestParams } from '@/models/Member/interfaces/IMemberNewNolInfoRequestParams';
import { IMemberViewCreateTokenRequestParams } from '@/models/Member/interfaces/IMemberViewCreateTokenRequestParams';
import MemberInternalGetCertJSC from '@/schema/MemberInternalGetCertJSC';
import MemberNewClaimsJSC from '@/schema/MemberNewClaimsJSC';
import MemberNewNolCheckConnectJSC from '@/schema/MemberNewNolCheckConnectJSC';
import MemberNewNolInfoJSC from '@/schema/MemberNewNolInfoJSC';
import MemberViewCreateTokenJSC from '@/schema/MemberViewCreateTokenJSC';
import { IRequestWrap } from '@/server/IServer';
import { TReqConfigValidated } from '@/services/JSCService';
import { joinURL } from '@/utils';
import { defaultTo } from 'ramda';

import { SunnyRequestBuilder } from '../Common/SunnyRequestBuilder';

export class MemberNewRequestBuilder extends SunnyRequestBuilder {
  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.Member;
  }

  createPostClaims(reqParams: IMemberNewClaimsRequestParams): TReqConfigValidated {
    return this.validate(MemberNewClaimsJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/authentication/claims', params),
    );
  }

  createGetNolInfo(reqParams: IMemberNewNolInfoRequestParams): TReqConfigValidated {
    return this.validate(MemberNewNolInfoJSC, reqParams).map((params) =>
      this.makeConfig('GET', `/members/${params.resources.memberNo}/linkage/nol`, params),
    );
  }

  createPutNolCheckConnect(reqParams: IMemberNewNolCheckConnectRequestParams): TReqConfigValidated {
    return this.validate(MemberNewNolCheckConnectJSC, reqParams).map((params) =>
      this.makeConfig('PUT', `/members/${params.resources.memberNo}/nol-check-connect`, params),
    );
  }

  createGetCert(reqParams: IMemberInternalGetCertRequestParams): TReqConfigValidated {
    return this.validate(MemberInternalGetCertJSC, reqParams).map((params) =>
      this.makeConfig('GET', `/members/${params.resources.memberNo}/certification`, params),
    );
  }

  protected getAPIEndpoint(path: string): string {
    const baseURI = this.baseURI.href();
    return baseURI ? joinURL(baseURI, path) : joinURL(baseURI, '/api/v1', path);
  }
}

export class MemberViewRequestBuilder extends SunnyRequestBuilder {
  protected makeHeaders = defaultTo({});

  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.MemberView;
  }

  createPostToken(reqParams: IMemberViewCreateTokenRequestParams): TReqConfigValidated {
    return this.validate(MemberViewCreateTokenJSC, reqParams).map((params) =>
      this.makeConfig('POST', '/authentication/reception', params),
    );
  }

  protected getAPIEndpoint(path: string): string {
    const baseURI = this.baseURI.href();
    return baseURI ? joinURL(baseURI, path) : joinURL(baseURI, '/api/v1', path);
  }
}
